// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"796":"19778ded86901a77","816":"910762003daa4b48"}[chunkId] + ".js";
};